import { User } from 'models/User';

export type BossModeAccoutnsTable = Pick<
  User,
  'firstName' | 'email' | 'phone' | 'createdAt' | 'promotedAt'
> &
  Record<'manage', any>;

export type BossModeAccoutnsTableKeys = Array<keyof BossModeAccoutnsTable>;

export const TABLE_COLUMNS: BossModeAccoutnsTableKeys = [
  'firstName',
  'email',
  'phone',
  'createdAt',
  'promotedAt',
  'manage',
];

type BossModeAccountsMap = Partial<
  Record<typeof TABLE_COLUMNS[number], string>
>;

export const HEADING_TRANSLATIONS: BossModeAccountsMap = {
  firstName: 'name',
  email: 'email',
  phone: 'phoneNumber',
  createdAt: 'joinedOn',
  promotedAt: 'promotedOn',
};

export const SORTING_VALUES: BossModeAccountsMap = {
  firstName: 'fullName',
  email: 'email',
  phone: 'contactNumber',
  createdAt: 'createdAt',
  promotedAt: 'promotedAt',
};

export const COLUMN_SIZE: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  manage: 50,
  email: 200,
  firstName: 200,
};
